import { render, staticRenderFns } from "./mypage.vue?vue&type=template&id=8574c842"
import script from "./mypage.vue?vue&type=script&lang=ts"
export * from "./mypage.vue?vue&type=script&lang=ts"
import style0 from "./mypage.vue?vue&type=style&index=0&id=8574c842&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports